<div class="shift-compliance-container">
	<h2 class="shift-compliance-header">Ready to get Started Today?</h2>
	<p class="shift-compliance-para">
		Our customer success team is standing by to partner with you on your
		Regulatory Operations journey. Contact us today to learn how you can
		bring DevOps to Compliance, enabling you to build and deliver
		continuously compliant documentation.
	</p>
	<div class="d-flex flex-column mt-5">
		<div class="d-flex mb-4">
			<img width="90px" src="../../assets/img/our-hq.svg" alt="" />
			<div class="ml-3">
				<div class="challenges-list-head">Find us at our HQ</div>
				<div class="challenges-list-content">
					RegScale, Inc.<br class="d-none d-xl-block" />
					1775 Tysons Boulevard, Fifth Floor<br
						class="d-none d-xl-block"
					/>
					Tysons, VA 22102
				</div>
			</div>
		</div>
		<div class="d-flex mb-4">
			<img width="90px" src="../../assets/img/our-hq.svg" alt="" />
			<div class="ml-3">
				<div class="challenges-list-head">
					Find us at our R&D Office
				</div>
				<div class="challenges-list-content">
					RegScale, Inc.<br class="d-none d-xl-block" />
					2704 Cherokee Farm Way, Suite 204<br
						class="d-none d-xl-block"
					/>
					Knoxville, TN 37920
				</div>
			</div>
		</div>
		<div class="d-flex">
			<img width="90px" src="../../assets/img/ring.svg" alt="" />
			<div class="ml-3">
				<div class="challenges-list-head">Give us a ring</div>
				<div class="challenges-list-content">
					RegScale Sales <br class="d-none d-xl-block" />
					202-991-7881 <br class="d-none d-xl-block" />
					Mon - Fri, 8:00 AM - 5:00 PM ET
				</div>
			</div>
		</div>
	</div>
</div>
